import React from "react";
import { motion } from "framer-motion";
import { IMAGES } from "../../lib/constants";

export const Banner28 = () => {
  const hasImage = !!IMAGES.banner28;
  return (
    <section
      className="relative w-full bg-[#1a0e08] overflow-hidden"
      data-testid="banner-28-anos"
      aria-label="28 anos do Restaurante O Padrinho"
    >
      {hasImage ? (
        <motion.img
          initial={{ scale: 1.06 }}
          whileInView={{ scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.4, ease: "easeOut" }}
          src={IMAGES.banner28}
          alt="28 anos de história, sabor e tradição — O Padrinho"
          className="block w-full h-auto object-contain"
        />
      ) : (
        <div
          className="w-full aspect-[16/7]"
          style={{
            background:
              "linear-gradient(135deg, #6a0000 0%, #8B0000 50%, #C9A84C 100%)",
          }}
        />
      )}
    </section>
  );
};

export default Banner28;
